import { gettext } from '@eventbrite/i18n';
import React from 'react';
import {
    EventDetailsMainInner,
    EventDetailsSectionTitle,
} from '../EventDetails/EventDetails';
import { Faq } from '../EventDetails/Widgets/Faq/Faq';
import { FaqWidget } from '../EventDetails/Widgets/Faq/types';

type Props = {
    widget: FaqWidget;
};

export const FAQSection: React.FC<Props> = ({ widget }) => {
    if (!widget) {
        return null;
    }

    return (
        <EventDetailsMainInner>
            <EventDetailsSectionTitle>
                <h2>{gettext('Frequently asked questions')}</h2>
            </EventDetailsSectionTitle>
            <Faq data={widget as FaqWidget} />
        </EventDetailsMainInner>
    );
};
